<app-loader *ngIf="isLoading" [loaderMsg]="rGuestBookMessages?.confirmation?.addingCardLoaderText"></app-loader>
<div class="container">
  <!-- To show Existing Card Detail  -->
  <div class="row justify-content-center">
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" *ngIf="cardList?.length">
      <ng-container
        *ngTemplateOutlet="
          creditCardTemplate;
            context: { card : cardList?.[0], isExistingCard: true, isCardSelected: isExistingCardSelected, isCardSelectedKey: 'isExistingCardSelected'}
          "></ng-container>
    </div>
  </div>

  <!-- To show Default Card with add icon  -->
  <div class="row justify-content-center" *ngIf="showDefaultCard">
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
      <ng-container
        *ngTemplateOutlet="creditCardTemplate; context: { card: defaultCard, isExistingCard: false, isDefaultCard: true }"></ng-container>
    </div>
  </div>

  <!-- To show newly added card along with iframe  -->
  <div class="row justify-content-center">
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
      <div *ngIf="tokenData?.cardInfo">
        <ng-container
          *ngTemplateOutlet="
            creditCardTemplate;
            context: {
              card: tokenData?.cardInfo,
              isExistingCard: false,
              isCardSelected: isNewCardSelected,
              isCardSelectedKey: 'isNewCardSelected'
            }
          "></ng-container>
      </div>

      <div
        class="col-xs-12 m-b-10"
        *ngIf="rGuestBookRoutePermissions.functionalPermissions.ShowCreditCardInfoText && paymentShowHide == 'block'">
        <mat-card class="creditCardText" [innerHTML]="rGuestBookMessages.myGuest.myGuestCreditCardInfoText"> </mat-card>
      </div>

      <div
        id="payment-information"
        class="col-xs-12 payment-information p-3 custom-payment-panel custom-payment-panel"
        [style.display]="paymentShowHide">
        <div class="panel panel-default credit-card-block">
          <div class="panel-heading" role="tab">
            <h4 class="panel-title">
              {{ rGuestBookMessages.cart.cartMessage4 }}
            </h4>
          </div>
          <div class="panel-body custom-panel-body">
            <div class="iframeLoader" [style.display]="iframeLoaderDisplay ? 'block' : 'none'">
              {{ rGuestBookMessages.cart.cartMessage5 }}
            </div>
            <div *ngIf="!setIframe && !iframePreloader" class="col-md-12 payment-information">
              <p>{{ rGuestBookMessages.cart.cartMessage3 }}</p>
            </div>
            <div *ngIf="iframePreloader" class="col-md-12 payment-information">
              <div class="text-center">
                <i class="animated-preload1 fa fa-circle faa-burst animated" aria-hidden="true"></i> &nbsp;
                <i class="animated-preload2 fa fa-circle faa-burst animated" aria-hidden="true"></i>&nbsp;
                <i class="animated-preload3 fa fa-circle faa-burst animated" aria-hidden="true"></i>&nbsp;
              </div>
            </div>
            <div [hidden]="!setIframe">
              <iframe
                title="Payment"
                *ngIf="iFrameData"
                #paymentIframe
                id="custom-frame"
                [src]="iFrameData | safe"
                id="fpframe"
                width="100%"
                height="500"
                scrolling="yes"
                frameborder="0"
                seamless
                [style.display]="!iframeLoaderDisplay ? 'block' : 'none'"></iframe>
            </div>

            <div class="col-xs-12 text-center"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Show existing card and newly added card with this template -->
<ng-template
  #creditCardTemplate
  let-card="card"
  let-isExistingCard="isExistingCard"
  let-isCardSelected="isCardSelected"
  let-isCardSelectedKey="isCardSelectedKey"
  let-isDefaultCard="isDefaultCard">
  <div class="col-xs-12 col-12 p-2 HeaderWrapper">
    <mat-card class="cardContent" [ngClass]="{ selectCreditCard: isCardSelected }" style="width: 100%">
      <div [ngClass]="{ flowDirBorder: cardIndex < cardList.length - 1 }" class="row flexPosition">
        <div class="col-12 existingCardHeader">
          <strong>{{
            isExistingCard
              ? rGuestBookMessages?.confirmation?.existingCardLabel
              : isDefaultCard
              ? rGuestBookMessages?.confirmation?.addNewCardLabel
              : rGuestBookMessages?.confirmation?.newlyAddedCardLabel
          }}</strong>
        </div>
        <mat-divider></mat-divider>
        <div class="col-12 flowDir">
          <div class="issuerIcon" class="col-2">
            <img alt="Card" class="cardIssuerLogo" src="assets/images/card/{{ card.cardIcon }}.svg" />
          </div>
          <div class="col-7">
            <div>
              <div>
                <span class="cardIssuerText">{{ card.cardIssuer | uppercase }}</span>
                <span [hidden]="isDefaultCard" class="mx-2">{{ rGuestBookMessages?.confirmation?.cardEndingText || "Ending with" }}</span>
                <span class="last4DigitText">{{ card.cardLastDig || card.accountNumberMasked }}</span>
              </div>
            </div>
          </div>
          <div class="col-3 desktopView">
            <div style="display: flex; justify-content: flex-end">
              <i [hidden]="!isDefaultCard" class="fas fa-plus-circle fa-lg addIcon" (click)="addNewCard()"></i>
              <h5 [hidden]="isCardSelected || isDefaultCard" (click)="selectCard(isCardSelectedKey, true)" class="selectContact selectCard">
                {{ rGuestBookMessages?.confirmation?.selectCardLabel || "Select" }}
              </h5>
              <h5
                [hidden]="!isCardSelected || isDefaultCard"
                (click)="selectCard(isCardSelectedKey, false)"
                class="deleteContact deleteCard">
                {{ rGuestBookMessages?.confirmation?.unSelectCardLabel || "Unselect" }}
              </h5>
              <em *ngIf="!isExistingCard && !isDefaultCard" class="fas fa-trash-alt cursor-pointer pl-2" (click)="removeNewCard()"></em>
            </div>
          </div>
          <div class="col-3 mobileView">
            <div style="display: flex; justify-content: flex-end">
              <em [hidden]="!isDefaultCard" class="fas fa-plus-circle fa-lg addIcon" (click)="addNewCard()"></em>
              <h5 [hidden]="isCardSelected || isDefaultCard" (click)="selectCard(isCardSelectedKey, true)" class="selectContact selectCard">
                {{ rGuestBookMessages?.confirmation?.selectCardLabel || "Select" }}
              </h5>
              <h5
                [hidden]="!isCardSelected || isDefaultCard"
                (click)="selectCard(isCardSelectedKey, false)"
                class="deleteContact deleteCard">
                {{ rGuestBookMessages?.confirmation?.unSelectCardLabel || "Unselect" }}
              </h5>
              <em *ngIf="!isExistingCard && !isDefaultCard" class="fas fa-trash-alt cursor-pointer pl-2" (click)="removeNewCard()"></em>
            </div>
          </div>
        </div>
      </div>
    </mat-card>
  </div>
</ng-template>
